   /*=========================================================================================
  File Name: state.js
  Description: Menus State
  ----------------------------------------------------------------------------------------
  Item Name: Menus State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    menus: [],
    itemsInRepository : [],
    currentMenuId : ''
}